/**
 * Internal Dependencies
 */
import themeOptions from "./components/theme-options";
import MobileNav from "./components/theme-navigation.js";
import "../scss/main.scss";
import "./vendor/match.js";

(function () {
  themeOptions();
  const mobileNav = new MobileNav();

  let $ = jQuery;

  $(".match").matchHeight();
})();
